// =============================================================================
// Design Tokens (from Figma)
// =============================================================================
export const SPACING = {
  sm: 6, // spacing-sm
  md: 8, // spacing-md
  lg: 12, // spacing-lg
  xl: 16, // spacing-xl
  '2xl': 20, // spacing-2xl
  '3xl': 24, // spacing-3xl
} as const;

export const RADIUS = {
  sm: 6, // radius-sm
  md: 8, // radius-md
  xl: 12, // radius-xl
  '2xl': 16, // radius-2xl
  full: 9999, // radius-full
} as const;

export const COLORS = {
  // Text colors
  textPrimary: '#181d27', // text-primary-900
  textSecondary: '#414651', // text-secondary-700 / fg-secondary-700
  textDisabled: '#717680', // text-disabled
  textPlaceholder: '#717680', // text-placeholder-500
  textQuaternary: '#a4a7ae', // fg-quaternary-400
  textWhite: '#ffffff', // text-white
  textError: '#d92d20', // error-600

  // Background colors
  bgPrimary: '#ffffff', // bg-primary
  bgHover: '#f9fafb', // bg-primary_hover
  bgActive: '#f5f5f5', // bg-active

  // Border colors
  borderPrimary: '#d5d7da', // border-primary
  borderSecondary: '#e9eaeb', // border-secondary
  borderSecondaryAlt: 'rgba(0, 0, 0, 0.08)', // border-secondary_alt
  borderError: '#fda29b', // error-300

  // Shadow colors
  shadowXs: 'rgba(10, 13, 18, 0.05)', // shadow-xs
  shadowXl01: 'rgba(10, 13, 18, 0.08)', // shadow-xl_01
  shadowXl02: 'rgba(10, 13, 18, 0.03)', // shadow-xl_02
  shadowXl03: 'rgba(10, 13, 18, 0.04)', // shadow-xl_03
  shadowError: 'rgba(240, 68, 56, 0.24)', // error focus shadow
} as const;

export const TYPOGRAPHY = {
  textSm: {
    fontSize: 14,
    lineHeight: '20px',
  },
  textMd: {
    fontSize: 16,
    lineHeight: '24px',
  },
} as const;

// Component dimensions from Figma
export const CALENDAR_WIDTH = 328;
export const NAV_BUTTON_SIZE = 32;
export const CALENDAR_CELL_SIZE = 40;
export const ICON_SIZE = 20;
export const DATE_INPUT_WIDTH = 136;

/**
 * Common date formats to try when parsing user input
 */
export const DATE_FORMATS = [
  // With separators
  'DD/MM/YYYY',
  'D/M/YYYY',
  'DD-MM-YYYY',
  'D-M-YYYY',
  'DD.MM.YYYY',
  'D.M.YYYY',
  'YYYY-MM-DD',
  'YYYY/MM/DD',
  // US format
  'MM/DD/YYYY',
  'M/D/YYYY',
  // Short year
  'DD/MM/YY',
  'D/M/YY',
  'DD-MM-YY',
  'D-M-YY',
  'DD.MM.YY',
  'D.M.YY',
  // Named months
  'D MMM YYYY',
  'D MMM, YYYY',
  'DD MMM YYYY',
  'DD MMM, YYYY',
  'D MMMM YYYY',
  'DD MMMM YYYY',
  // German format
  'DD. MMM, YYYY',
  'DD. MMMM YYYY',
] as const;
